export function getTextColorFromBg(
  bgColor: string,
  lightText = "text-foreground",
  darkText = "text-primary-foreground",
): string {
  if (!bgColor || !bgColor.startsWith("#")) return lightText;

  const hex = bgColor.replace("#", "");
  const r = parseInt(
    hex.length === 3 ? hex[0] + hex[0] : hex.substring(0, 2),
    16,
  );
  const g = parseInt(
    hex.length === 3 ? hex[1] + hex[1] : hex.substring(2, 4),
    16,
  );
  const b = parseInt(
    hex.length === 3 ? hex[2] + hex[2] : hex.substring(4, 6),
    16,
  );

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5 ? lightText : darkText;
}

export function TextColorClassOrStyle(
  color: string | undefined,
  fallbackClass: string,
): {
  className?: string;
  style?: React.CSSProperties;
} {
  if (!color) {
    return { className: fallbackClass };
  }

  const isColorCode = /^(#|rgb|hsl)/.test(color);
  const isTextClass = color.startsWith("text-");

  if (isColorCode) {
    return { style: { color } };
  }

  if (isTextClass) {
    return { className: color };
  }

  // fallback nếu không hợp lệ
  return { className: fallbackClass };
}

export function SectionTitleColor() {}
